<template>
  <BaseDataIterator :service="fetchData" disable-search>
    <template #default="dataIteratorProps">
      <BaseDataTable :data="dataIteratorProps.data">
        <template #default="dataTableProps">
          <EmailTemplateListItem
            :email-template="dataTableProps.item"
            @duplicated="dataIteratorProps.resetList"
            @deleted="dataIteratorProps.resetList"
          />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountEmailTemplatesClient } from '@/api/clients';
import EmailTemplateListItem from './EmailTemplateListItem.vue';

export default {
  components: {
    EmailTemplateListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    fetchData(queryParams = {}) {
      return accountEmailTemplatesClient.list(this.accountId, {
        ...queryParams,
        include: 'preview',
      });
    },
  },
};
</script>
